/**
 * Full GraphQL Schema including both the client schema and server schema.
 *
 * Note, this schema cannot be used to execute a query.
 * https://graphql.org/graphql-js/utilities/#buildastschema
 */
import {mergeTypeDefs} from '@graphql-tools/merge';
import {buildASTSchema} from 'graphql';

import GraphQLClientSchemaDef from 'graphql-client/schema/GraphQLClientSchemaDef';
import GraphQLServerSchemaDef from 'graphql-client/schema/GraphQLServerSchemaDef';

export const GraphQLSchemaDef = mergeTypeDefs([GraphQLClientSchemaDef, GraphQLServerSchemaDef]);
const GraphQLSchema = buildASTSchema(GraphQLSchemaDef, {assumeValid: true});

export default GraphQLSchema;
